import React from 'react';
import { useScrollToAnchor } from '../../../hooks/uaeScrollToAnchor';
import Button from './Button';

const AnchorButton = ({ anchorId, bgcolor, text, icon, className, onClick, ...props }) => {
 
  const scrollToAnchor = useScrollToAnchor();

  const handleClick = () => {
    if (anchorId) {
      scrollToAnchor(anchorId);
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <Button
      color={bgcolor || "#00BBA7"}
      text={text}
      iconName={icon}
      className={className}
      onClick={handleClick}
      {...props}
    />
  );
};

export default AnchorButton;

